export default {
	styleOverrides: {
		root: {
			minWidth: 0,
		},
	},
}
